<template>
  <div data-testid="last-logged-in-users-container">
    <div class="d-flex justify-space-between mb-2">
      <div class="headline6" data-testid="last-logged-in-users-header">
        {{ $t("general.lastLoggedInUsers") }}
      </div>
    </div>
    <div class="last-logged-in-users-list">
      <v-table
        v-if="lastLoggedInUsers.length"
        class="last-logged-in-users-list__table"
        data-testid="last-logged-in-users-table"
      >
        <template #default>
          <tbody>
            <tr
              v-for="user in lastLoggedInUsers"
              :key="user"
              data-testid="last-logged-in-users-row"
            >
              <td
                class="text-left user-col subtitle2 pl-4 py-3"
                data-testid="last-logged-in-users-username"
              >
                {{ user }}
              </td>
            </tr>
          </tbody>
        </template>
      </v-table>
      <div
        v-else
        class="d-flex flex-column align-center justify-center pa-7"
        data-testid="last-logged-in-users-empty-state"
      >
        <v-icon size="80" icon="$groups" data-testid="last-logged-in-users-empty-icon" />
        <span class="subtitle1" data-testid="last-logged-in-users-empty-message">{{
          $t("general.noRecentLogins")
        }}</span>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
defineProps<{ lastLoggedInUsers: string[] }>();
</script>
<style lang="scss" scoped>
.last-logged-in-users-list {
  border: 1px solid rgb(var(--v-theme-indigo-faint));
}

.icon-users-s:before {
  color: rgb(var(--v-theme-indigo-light)) !important;
}

:deep(*) {
  .last-logged-in-users-list__table {
    .v-data-table__wrapper {
      box-shadow: none !important;
      border-radius: 0 !important;
    }
  }
}
</style>
